"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require("immutable");

var I = _interopRequireWildcard(_immutable);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queryString = require("query-string");

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Column = function Column(props, context) {
  var children = props.children;
  var ordering = props.ordering;

  if (!ordering) {
    return _react2.default.createElement(
      "th",
      { className: "erg-components-Column" },
      children
    );
  }
  ordering = Array.isArray(ordering) ? I.OrderedSet(ordering) : I.OrderedSet([ordering]);

  var _context$location = context.location,
      pathname = _context$location.pathname,
      query = _context$location.query,
      history = context.history;

  var orderingSet = I.OrderedSet(props.currentOrdering ? props.currentOrdering.split(",") : undefined);
  var reverseOrdering = ordering.map(function (name) {
    var isReversed = name[0] === "-";
    return isReversed ? name.slice(1) : "-" + name;
  });

  var isOrdered = ordering.isSubset(orderingSet);
  var isReverseOrdered = reverseOrdering.isSubset(orderingSet);

  var arrowClassName = (0, _classnames2.default)("fa", {
    "fa-caret-down": isOrdered,
    "fa-caret-up": isReverseOrdered
  });

  var arrowContent = void 0;
  var newOrdering = void 0;
  if (isOrdered) {
    arrowContent = _react2.default.createElement(
      "a",
      {
        className: "erg-margin-left-5",
        onClick: function onClick() {
          return history.push({
            pathname: pathname,
            search: "?" + _queryString2.default.stringify(_extends({}, query, {
              ordering: orderingSet.filter(function (name) {
                return !ordering.has(name);
              }).toArray().join(",")
            }))
          });
        } },
      _react2.default.createElement("i", { className: arrowClassName })
    );
    newOrdering = orderingSet.filter(function (name) {
      return !ordering.has(name);
    }).concat(reverseOrdering);
  } else if (isReverseOrdered) {
    arrowContent = _react2.default.createElement(
      "a",
      {
        className: "erg-margin-left-5",
        onClick: function onClick() {
          return history.push({
            pathname: pathname,
            search: "?" + _queryString2.default.stringify(_extends({}, query, {
              ordering: orderingSet.filter(function (name) {
                return !reverseOrdering.has(name);
              }).toArray().join(",")
            }))
          });
        } },
      _react2.default.createElement("i", { className: arrowClassName })
    );
    newOrdering = orderingSet.filter(function (name) {
      return !reverseOrdering.has(name);
    }).concat(ordering);
  } else {
    newOrdering = orderingSet.concat(ordering);
  }
  return _react2.default.createElement(
    "th",
    { className: "erg-components-Column" },
    _react2.default.createElement(
      "a",
      {
        onClick: function onClick() {
          return history.push({
            pathname: pathname,
            search: "?" + _queryString2.default.stringify(_extends({}, query, {
              ordering: newOrdering.toArray().join(",")
            }))
          });
        } },
      children
    ),
    arrowContent
  );
};

Column.contextTypes = {
  location: _propTypes2.default.object,
  history: _propTypes2.default.object.isRequired
};
Column.defaultProps = {
  currentOrdering: ""
};
Column.propTypes = {
  children: _propTypes2.default.node.isRequired,
  component: _propTypes2.default.oneOfType([// eslint-disable-line react/no-unused-prop-types
  _propTypes2.default.func, _propTypes2.default.object]),
  componentProps: _propTypes2.default.object, // eslint-disable-line react/no-unused-prop-types
  currentOrdering: _propTypes2.default.string,
  ordering: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  renderer: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  value: _propTypes2.default.oneOfType([// eslint-disable-line react/no-unused-prop-types
  _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};

exports.default = Column;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/table/Column.js
 ** module id = 796
 ** module chunks = 0
 **/